import { FIN_IMG_PRE_PATH, GROUP_IMG_PRE_PATH, GOV_IMG_PRE_PATH, LINK_PRE_PATH, UrlPre } from './index';

export const headBg = UrlPre + 'PC/finance.jpg ';
export const headBgM = UrlPre + 'M/finance.jpg';
export const frameSrc = FIN_IMG_PRE_PATH + 'pc/5b43f6da3b3f6799a9c9c120dcdc9ac996125a792ece0f9a6c7cd0f8d3e1b585.jpg';
export const frameSrcM = FIN_IMG_PRE_PATH + 'm/68eae56fd213ac599b87c9087274a1c8a34e80b5fc553a0c89371f9d2e8ff92b.jpg';

export const challenge = [
  {
    icon: FIN_IMG_PRE_PATH + 'pc/a82679b97abfb89d13a4c0e75de2b0e7546f5d82aa60f58f568ec58793b4a842.png',
    title: '旧系统设备不一，孤岛式应用',
    desc: '各组织及部门设备基础各异，传统视频会议难以满足高效协同需求，亟需打破信息孤岛',
  },
  {
    icon: FIN_IMG_PRE_PATH + 'pc/56dfb014c31df71cc849b7472981c561fd09319e16816edf2b9a44ebf79e058b.png',
    title: '基层网点多、分布广、传达难',
    desc: '金融网点和各级员工分布广泛分散，亟需优化流程，让信息快速覆盖到一线，提升工作效能',
  },
  {
    icon: FIN_IMG_PRE_PATH + 'pc/b283a22cdb8da99b5fd88f828df1195aa1450677e8d856a6f584393f44c48510.png',
    title: '业务线专业复杂，场景应用难拓展',
    desc: '除视频会议、客户指导、远程客服、业务培训外，亟需深入金融业务流程拓展场景应用',
  },
  {
    icon: FIN_IMG_PRE_PATH + 'pc/5d60af7d8865739a403cb9e2b7904ff9401c6a521069533eb5a56648e2045838.png',
    title: '对信息安全及稳定性要求极高',
    desc: '金融风险复杂度高，对信息安全及数据保密具有高标准，更强调国产化及应用稳定性',
  },
];
export const frame = [
  {
    title: '高效视频协同',
    icon: GOV_IMG_PRE_PATH + 'pc/bfb3d4b4b4b6729fa3595f0fc4c1ebb598a04a7d88399377c7eebc230cd20d0f.png',
  },
  {
    title: '设备兼容利旧',
    icon: GROUP_IMG_PRE_PATH + 'pc/1efd342155c574e9a0f7fa8c701863d275ed69f43b8f446402cf3ab34abc2e39.png',
  },
  {
    title: '嵌入业务场景',
    icon: GROUP_IMG_PRE_PATH + 'pc/755d6bc43121cef1bdeb80dbbab62bc8755abd23da0beac56f5c2f3e14c7193b.png',
  },
  {
    title: '信息安全稳定',
    icon: GOV_IMG_PRE_PATH + 'pc/7b22bddde2da475aff0ab5230102043bb66f9ffc7790e93bf76916e401538b8b.png',
  },
];
export const advantage = [
  {
    icon: GROUP_IMG_PRE_PATH + 'pc/68979ad392e91c378cf24b24c95fffd44bfc3d080c65373c0a037be1314f36c8.png',
    title: '超融合应用',
    desc: '视频会议、监控、直播、录播、数据、语音融合互通，统一媒体接入能力，支撑金融各类业务应用',
  },
  {
    icon: GOV_IMG_PRE_PATH + 'pc/ba7fb7ba0a0f40557012ce829250051134a7fa360fd790dde54e3b843ca4fa6a.png',
    title: '高安全保密',
    desc: '全自研底层技术，国密算法端到端全链路加密，架构级安全保障，通过等保三级2.0+可信云双重安全资质认证',
  },
  {
    icon: GROUP_IMG_PRE_PATH + 'pc/faf1f6749cd9696565108b7f79fbfdd524c6bfce90020c55138f9eaf87719206.png',
    title: '全场景覆盖',
    desc: '覆盖智慧柜台、大中小会议室、桌面、移动端等各类型终端，可灵活接入金融内外网、金融专网、互联网、4G/5G等多网络环境',
  },
  {
    icon: GROUP_IMG_PRE_PATH + 'pc/639e7221ee58ef1e94d0afd1196f9cb72749b9587fbd06811784cd9bd472744c.png',
    title: '助降本增效',
    desc: '云视频方案应用成本远低于传统硬件视频会议，金融方案部署简单，使用便捷高效，运维成本低',
  },
  {
    icon: GROUP_IMG_PRE_PATH + 'pc/0c61ed2215d72793a025f868960559d79e32f8736569b0be67c1f23132891983.png',
    title: '超高清体验',
    desc: '具备完全自主核心知识产权，“云+端”国产化软硬件方案有效保障1080P/4K超高清体验',
  },
  {
    icon: GROUP_IMG_PRE_PATH + 'pc/72abb4a6fb3e84800a01164b1497efa20ae197c93d1213928156bb947035a3b0.png',
    title: '开放式集成',
    desc: '全面开放API/SDK，可融合金融现有音视频能力、金融业务系统，扩展AI能力，深度融合业务场景',
  },
];
export const scene = [
  {
    title: '晨夕大会',
    desc: '根据会议级别召开各类金融业务会议，覆盖范围从总部贯穿至网点',
    pcUrl: FIN_IMG_PRE_PATH + 'pc/ac901cba1b462318bb2c4ba8f73ea1fa183e84a1a4d665055c668afdae403bd8.jpg',
  },
  {
    title: '商务会议',
    desc: '构建安全、保密、流畅的线上商务会议环境，满足各层级外部洽谈需求',
    pcUrl: FIN_IMG_PRE_PATH + '25523c5373185aea531a5ae705bae48cd109037e07fe8b55b46587376ef27502.jpg',
  },
  {
    title: '协同办公',
    desc: '覆盖金融机构内部人员，随时随地发起跨区域、跨部门在线视频协同',
    pcUrl: FIN_IMG_PRE_PATH + '84f1173b88f43306cf487ccc1b5505aa9c725e49a6bd0c82ad95c457aca6c74a.jpg',
  },
  {
    title: '视频存证',
    desc: '远程视频核实用户对金融业务办理的真实意愿及权责理解，减少纠纷',
    pcUrl: FIN_IMG_PRE_PATH + 'edcef13f9bc02cc53774742f58d537a40c6e12834a806abd9b1e51ddc44cb70e.jpg',
  },
  {
    title: '视频客服',
    desc: '升级语音客服为视频客服并无缝嵌入业务端，实现金融服务升级',
    pcUrl: FIN_IMG_PRE_PATH + 'pc/86eb3fdda5e12c7da46e69a7bb9bd8f67eadf6dd46c60f13453d2142cf44012d.jpg',
  },
  {
    title: '智慧网点',
    desc: '降低基层网点运维压力，实现专人响应客户业务咨询及实时远程指导',
    pcUrl: FIN_IMG_PRE_PATH + 'pc/0833f710ceecfe7fa934d49953e185782f4a655f533c1fe763d7ba8f71a8353a.jpg',
  },
];
export const caseList = [
  [
    {
      logo: FIN_IMG_PRE_PATH + 'pc/35c1191723f5a6002e18d61f8748e71d6730124ace00f050379deac1a7c80b82.jpg',
      title: '中国建设银行',
      desc: '中国建设银行依托小鱼易连云视频，建设了建设银行龙视讯云平台，平台支持全行海量用户的移动视频会议需求，“超高清、低延时、高效便捷”的云视频，能大幅提升行内远程视频会议体验，同时，小鱼易连也满足董事会同声传译、个贷远程面签、信贷双录、远程审计、龙集采等各类创新场景应用，助力中国建设银行数字化转型。',
      link: LINK_PRE_PATH + '1098',
    },
    {
      logo: FIN_IMG_PRE_PATH + 'pc/a45ebd600e81d74fc1aa9e0f869ac32420b00aa75afffa7f4c4ff4b94988c72d.jpg',
      title: '中国光大银行',
      desc: '中国光大银行携手小鱼易连打造光大多媒体云视频会议系统，满足了光大银行内部沟通协作、内外体系互通互联需求，实现“一个平台统一调度”的效果。光大多媒体云视频会议系统，覆盖了39家分行、1058家支行网点及619家社区银行，满足光大银行的日常会议、业务培训以及线上服务等多场景应用。',
      link: LINK_PRE_PATH + '6c26e3',
    },
    {
      logo: FIN_IMG_PRE_PATH + 'pc/7e08c2e6565a1367e1632d4d257010fea1f0c17054c1702d24480079534f937c.jpg',
      title: '北京银行股份有限公司',
      desc: '北京银行股份有限公司应用小鱼易连云视频，为总行、科技大厦、研发中心等建立可视化的远程沟通新链路，满足各部门的日常办公和协作。同时，北京银行也通过小鱼易连API接口，与行内办公系统“易点办公”、“京智办公”进行深度融合，推出的视频会议小程序、在线会议室等应用，支撑了全行的视频会议、移动办公等多场景视频应用需求。',
      link: LINK_PRE_PATH + '1098',
    },
    {
      logo: FIN_IMG_PRE_PATH + 'pc/b55ba2934892e59ec59a547d53f385164d8ba96a7d8ed629d37c3b7e602ff9c4.jpg',
      title: '阳光保险集团股份有限公司',
      desc: '阳光保险集团股份有限公司携手小鱼易连，打造覆盖了全集团的阳光云会议系统，实现视频业务的快速互联和全方位音视频协同，实现传统视频会议系统、统一会管系统、云视频、直播平台的全面打通，满足全集团“点对点、多对多”互动云视频会议和大规模直播需求，对推动“晨夕大会、业务培训、视频客服、智慧网点、职场监管”等创新应用覆盖发挥示范作用。',
      link: LINK_PRE_PATH + '1099',
    },
  ],
];
